import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { OrderService } from '../../../services/order.service';
import { isNullOrUndefined } from 'is-what';
import { ActivatedRoute, Router } from '@angular/router';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { MessageService } from 'primeng/api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Paginator } from 'primeng/paginator';
import moment from 'moment/moment';
import { StorageService } from 'src/app/services/storage.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CatEditService } from 'src/app/services/cat-edit.service';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

import * as JSZip from 'jszip';
import { HttpClient } from '@angular/common/http';
import { forEach } from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { UnsubscribeService } from 'src/app/services/unsubscribe.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { TableColumn, DataTableComponent } from 'src/app/shared-components/data-table/data-table.component';

export function noSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && typeof control.value === 'string') {
      if (control.value.trim().length === 0) {
        return { noSpaces: true };
      }
    }
    return null;
  };
}

@Component({
    selector: 'app-bulk-orders',
    templateUrl: './bulk-orders.component.html',
    styleUrls: ['./bulk-orders.component.scss'],
    standalone: false
})
export class BulkOrdersComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('paginatorComponent') paginator: Paginator;
  @ViewChild('viewStampOrder') viewStampOrder: TemplateRef<any>;
  @ViewChild('viewExcel') viewExcel: TemplateRef<any>;
  @ViewChild('viewOrderData') viewOrderData: TemplateRef<any>;
  @ViewChild('bulkTable') bulkTable: DataTableComponent;

  @Input() orderOption: any = [];
  @Output() bulkOrderChange: EventEmitter<any> = new EventEmitter<[]>();

  readonly bulkColumns: TableColumn[] = [
    { field: 'id', header: 'Order No', sortable: true },
    { field: 'number_of_orders', header: 'No of Orders' },
    { field: 'account_name', header: 'Account Name', sortable: true },
    { field: 'user', header: 'Ordered by', sortable: true },
    { field: 'created', header: 'Order Date', sortable: true, pipe: 'date:dd/MM/yyyy hh:mm a' },
    { field: 'status', header: 'Status', sortable: true },
    { field: 'action', header: 'Action', toggleable: false },
    { field: 'progress', header: 'Progress', toggleable: false },
  ];

  readonly orderColumns: TableColumn[] = [
    { field: 'id', header: 'Order No', sortable: true },
    { field: 'user', header: 'Ordered by', sortable: true },
    { field: 'referance_id', header: 'Ref. ID', sortable: true },
    {
      field: 'estamp_info.0.second_party_name',
      sortField: 'second_party_name',
      header: 'Second Party',
      sortable: true,
      fallback: '----',
      truncate: 20,
      tooltip: true,
    },
    { field: 'created', header: 'Order Date', sortable: true, pipe: 'date:dd/MM/yyyy hh:mm a' },
    { field: 'order_type', header: 'Order Type', sortable: true },
    { field: 'status', header: 'Status', sortable: true },
    { field: 'branch', header: 'Branch', sortable: true },
    {
      field: 'amount',
      header: 'Stamp Amount',
      sortable: true,
      accessorFn: (row) => (row.estamp_info.length > 0 ? this.calculateTotalStampDuty(row.estamp_info) : null),
      fallback: 'NA',
    },
    { field: 'action', header: 'Action', toggleable: false },
  ];

  readonly rowClassFor = (row: any): string =>
    this.id !== null && row.id == this.id ? 'selectedRow' : '';

  tabIndex: number = 0;
  headerData: any = [];
  rowData: any = [];
  tableRows: any = [];
  valueDate: any = [];
  isViewMoreClicked: boolean = false;
  bulkPageNo: number = 1;
  orderPageNo: number = 1;
  totalRecords: number = 10;
  totalOrderRecords: number = 10;
  bulkOrders: any = [];
  orders: any = [];
  selectedOrder: any;
  selectedBulkOrder: any;
  BulkOrderMiniData: [] = [];
  isExporting: boolean = false;

  estampFilters = { estamp_fields: [] };
  fieldsToDisplay: any = [
    'user_name',
    'order_status',
    'user_email',
    'branch',
    'state',
    'order_type',
    'account',
    'total_stamps',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'total_stamps_amount',
    'execution_date',
    'certificate_number',
    'referance_number',
    'issued_date',
    'denomination',
    'cess_amount',
    'email',
    'sign_method',
    'status',
    'sign_url',
    'signed_at',
  ];
  orderFilters = {
    action_type: 'bulk',
    page_number: 1,
    page_size: 10,
    start_date: '',
    end_date: '',
  };
  id: any;
  currentSortColumn: string = '';
  sortDirection: string = 'asc';
  bulkOrderId: any;
  ordersCount: any;
  pendingSignature: any;
  stateData: any;
  branchData: any;
  submitted: boolean;
  editOrderForm: FormGroup;
  editOrderId: any;
  minDate = new Date();
  stampDutyPaidByOptions = [
    { name: 'First Party', code: 'first_party_name' },
    { name: 'Second Party', code: 'second_party_name' },
  ];
  selectedOrderForEdit: any;
  estampForms: FormArray;
  commonFieldsOrderForm: FormGroup;
  esignForms: FormArray;
  orderDetail: any;
  public phonePattern: string = '[0-9]{10}';
  editEsignForm: FormGroup;
  editEstampForm: FormGroup;
  rowsPerPageOptions: number[];
  rowsPerPage: any = 10;
  rowsPerPageOptionsForViewMore: number[];
  rowsPerPageForViewMore: any = 10;
  stateStatusArray: any = [];
  searchPageNumber: number = 1;
  numberoftables: number;
  numberoftablesOrder: number;
  DATE_FORMAT = 'YYYY-MM-DD';
  viewMorerderFilters = {
    action_type: 'bulk',
    bulk_order_ids: '',
    page_number: this.orderPageNo,
    page_size: 2,
  };
  loggedEmail: any;
  bulkOrderStatus: any = '';
  reviewMode: boolean = false;
  reviewEmailData: any = [];
  orderDocument: any;
  showDownloadDoc: boolean;
  fileURL: string;
  pdfSource: SafeResourceUrl;
  excelDocument: any;
  fileName: string;
  orderCreatedOn: any;
  excelSource: SafeResourceUrl;
  jsonData: any;
  excelOrderId: any;
  viewOrderId: any;
  ordersCountProgressBar: { completed_orders: number; total_orders: number }[] =
    [];
  progressPercentage: any[] = [];
  progressBarTooltip: any[] = [];
  noRecordMsg: string;
  checkOrder: { id: any };
  bulkOrderID: any;
  percentageColumns: Set<number> = new Set();
  private destroy$ = new Subject<void>();
  constructor(
    private orderService: OrderService,
    private messageService: MessageService,
    private storageService: StorageService,
    private catEditService: CatEditService,
    private route: ActivatedRoute,
    private pathRoute: Router,

    private exportExcelService: ExportExcelService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private unsubscribeService: UnsubscribeService,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService
  ) {
    this.loggedEmail = this.storageService.getLoginEmail() || null;
    this.orderFilters['account_id'] =
      this.storageService.getAccountId() || null;
    this.commonFieldsOrderForm = this.formBuilder.group({
      referenceNumber: [''],
      branch: [''],
      state: [''],
    });

    this.estampForms = this.formBuilder.array([]);

    this.editEstampForm = this.formBuilder.group({
      estamp_id: [''],
      secondPartyName: [''],
      stampDutyValue: [''],
      stampDutyPaidBy: [''],
      execution_date: [''],
      estamp_info: this.estampForms,
    });

    this.esignForms = this.formBuilder.array([]);

    this.editEsignForm = this.formBuilder.group({
      esign_id: [''],
      name: [''],
      email: [''],
      contact_number: [''],
      esign_info: this.esignForms,
    });
  }

  ngOnInit(): void {
    this.getStateDetails();

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((queryParams) => {
      this.id = queryParams?.id;
      this.orderCreatedOn = queryParams?.createdOn;
      if (this.orderCreatedOn) {
        this.orderFilters.start_date = moment(
          new Date(this.orderCreatedOn)
        ).format(this.DATE_FORMAT);
        this.orderFilters.end_date = moment(
          new Date(this.orderCreatedOn)
        ).format(this.DATE_FORMAT);
      } else {
        this.orderCreatedOn = new Date();
        // No explicit createdOn deep-link: leave start_date/end_date as set by
        // ngOnChanges (30-day default / date-range filter), don't clobber it here.

      //    const thirtyDaysAgo = new Date();
      //   thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 7);
      //   this.orderFilters.start_date = moment(new Date(thirtyDaysAgo)).format(
      //     this.DATE_FORMAT
      //   );
      //   this.orderFilters.end_date = moment(
      //     new Date(this.orderCreatedOn)
      //   ).format(this.DATE_FORMAT);
      }
    });

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((queryParams) => {
      this.bulkOrderId = queryParams?.bulkOrderid;
      if (this.bulkOrderId) {
        const order = { id: this.bulkOrderId };
        this.checkOrder = order;
        this.onViewMore(order);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.id = this.route.snapshot.paramMap.get('id');

    if (changes['orderOption']) {
      if (changes['orderOption'].currentValue['tabIndex'] == 1) {
        const branch_ids = changes['orderOption'].currentValue['branch_ids'];
        const searchText = changes['orderOption'].currentValue['searchText'];
        const serviceType = changes['orderOption'].currentValue['serviceType'];
        const orderStatus =
          changes['orderOption'].currentValue['bulkOrderStatus'];
        const startDate = changes['orderOption'].currentValue['startDate'];
        const endDate = changes['orderOption'].currentValue['endDate'];
        const orderId = changes['orderOption'].currentValue['bulkSingle_ids'];
        this.isViewMoreClicked =
          changes['orderOption'].currentValue['isViewMoreClicked'];
        const bulkOrderIds =
          changes['orderOption'].currentValue['bulk_order_id'];

        if (bulkOrderIds && bulkOrderIds.length > 0) {
          this.orderFilters['bulk_order_id'] = bulkOrderIds;
          this.viewMorerderFilters['bulk_order_ids'] = bulkOrderIds;
          delete this.orderFilters['start_date'];
          delete this.orderFilters['end_date'];
        } else {
          delete this.orderFilters['bulk_order_id'];
          //delete this.viewMorerderFilters["bulk_order_ids"];
          const thirtyDaysAgo = new Date();
          thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
          this.orderFilters.start_date = moment(thirtyDaysAgo).format(
            this.DATE_FORMAT
          );
          this.orderFilters.end_date = moment(new Date()).format(
            this.DATE_FORMAT
          );
        }

        if (searchText.length > 1) {
          this.orderFilters['search'] = searchText;
          this.viewMorerderFilters['search'] = searchText;
        } else {
          delete this.orderFilters['search'];
          delete this.viewMorerderFilters['search'];
        }
        if (branch_ids && !isNullOrUndefined(branch_ids)) {
          this.orderFilters['branch_ids'] = branch_ids;
        } else {
          delete this.orderFilters['branch_ids'];
        }

        if (serviceType && !isNullOrUndefined(serviceType)) {
          this.orderFilters['order_type'] = serviceType;
        } else {
          delete this.orderFilters['order_type'];
        }

        if (
          orderStatus &&
          !isNullOrUndefined(orderStatus) &&
          orderStatus.length != 0
        ) {
          this.orderFilters['bulk_status'] = orderStatus;
          this.viewMorerderFilters['status'] = orderStatus;
        } else {
          delete this.orderFilters['bulk_status'];
          delete this.viewMorerderFilters['status'];
        }

        if (
          startDate &&
          endDate &&
          !isNullOrUndefined(startDate) &&
          !isNullOrUndefined(endDate)
        ) {
          this.orderFilters['start_date'] = startDate;
          this.orderFilters['end_date'] = endDate;
        }

        if (orderId) {
          let order = { id: orderId };
          this.viewIndividualOrder(order, this.viewOrderData);
        } else if (this.id) {
          this.orderFilters['bulk_order_id'] = this.id;
          delete this.orderFilters['start_date'];
          delete this.orderFilters['end_date'];
        }

        if (this.isViewMoreClicked) {
          this.getOrders(this.viewMorerderFilters);
        } else {
          this.getBulkOrders();
        }
      }
    }
  }

  onViewMore(order) {
    this.isViewMoreClicked = true;
    this.bulkOrderChange.emit(this.isViewMoreClicked);
    this.selectedOrder = order;
    this.viewMorerderFilters.bulk_order_ids = this.selectedOrder.id;
    this.viewMorerderFilters.page_number = this.orderPageNo;
    this.bulkOrderStatus = order.status;
    this.getOrders(this.viewMorerderFilters);
  }

  sendtoOrderListing() {
    this.bulkOrderChange.emit('Bulk');
  }

  getBulkOrders() {
    const currentDate = moment().format(this.DATE_FORMAT);

    this.orderService.getBulkOrders(this.orderFilters).subscribe(
      (resp) => {
        if (resp.status == 200 && resp.message !== 'No records found') {
          this.bulkOrders = [...resp.content];

          this.BulkOrderMiniData = this.bulkOrders.map((order) => order.id);
          console.log(
            this.BulkOrderMiniData,
            'bulkorders details--------------------------->'
          );
          this.totalRecords = resp.pagination.total_records;
          this.searchPageNumber = resp.pagination.page_number;
          this.numberoftables = Math.ceil(this.totalRecords / this.rowsPerPage);
          // this.calculateRowsPerPageOptions()

          // Initialize ordersCountProgressBar with the same length as bulkOrders
          this.ordersCountProgressBar = new Array(this.bulkOrders.length).fill({
            completed_orders: 0,
            total_orders: 0,
          });

          this.bulkOrders.forEach((order, index) => {
            if (order.created && typeof order.created === 'string') {
              const parts = order.created.trim().split(/\s+/);
              if (parts.length === 3) {
                const [datePart, timePart, meridiem] = parts;
                const [hourStr, minuteStr] = timePart.split(':');
                let hours = parseInt(hourStr, 10);
                if (meridiem.toUpperCase() === 'PM' && hours !== 12) hours += 12;
                if (meridiem.toUpperCase() === 'AM' && hours === 12) hours = 0;
                order.created = `${datePart}T${hours.toString().padStart(2, '0')}:${minuteStr}:00`;
              }
            }
            if (this.ordersCountProgressBar[index]) {
              this.ordersCountProgressBar[index].completed_orders =
                order.complated_orders;
              this.ordersCountProgressBar[index].total_orders =
                order.number_of_orders;
              this.getProgressPercentage(index);
              this.getTooltipText(index);
            }
          });
        } else {
          this.bulkOrders = [];
          this.totalRecords = 0;
          if (
            this.orderFilters.start_date === currentDate &&
            this.orderFilters.end_date === currentDate
          ) {
            this.noRecordMsg = 'No records found for today';
          } else {
            this.noRecordMsg = 'No records found';
          }
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.bulkOrders = [];
        this.totalRecords = 0;
        this.cdr.detectChanges();
      }
    );
  }

  getOrders(params) {
    if (params.bulk_order_ids || params.search || params.orderStatus) {
      this.orderService.getOrders(params).subscribe((resp) => {
        if (resp.status == 200 && resp.message !== 'No records found') {
          this.orders = [...resp.content];
          this.selectedBulkOrder = this.orders[0];
          this.totalOrderRecords = resp.pagination.total_records;
          this.reviewEmailData = this.orders[0].order_reviewers;

          if (this.selectedBulkOrder) {
          this.analyticsService.trackEvent('click_view_order_bulk', {
            order_id: this.selectedBulkOrder.bulk_order,
            account_id: this.selectedBulkOrder.account?.id || null,
            organisation_name: this.selectedBulkOrder.account?.organisation_name || null,
            account_name: this.selectedBulkOrder.account?.account_name || null
          });
         }

          if (this.reviewEmailData.length != 0) {
            this.reviewMode = this.reviewEmailData.find(
              (item) => item.reviewer === this.loggedEmail
            );
          }
          this.searchPageNumber = resp.pagination.page_number;
          this.numberoftablesOrder = Math.ceil(
            this.totalOrderRecords / this.rowsPerPage
          );
          this.orders.forEach((element) => {
            if (element.created && typeof element.created === 'string') {
              const parts = element.created.trim().split(/\s+/);
              if (parts.length === 3) {
                const [datePart, timePart, meridiem] = parts;
                const [hourStr, minuteStr] = timePart.split(':');
                let hours = parseInt(hourStr, 10);
                if (meridiem.toUpperCase() === 'PM' && hours !== 12) hours += 12;
                if (meridiem.toUpperCase() === 'AM' && hours === 12) hours = 0;
                element.created = `${datePart}T${hours.toString().padStart(2, '0')}:${minuteStr}:00`;
              }
            }
            if (element.status === 'Waiting for Approval') {
              this.bulkOrderStatus = 'WAITING_FOR_APPROVAL';
              this.reviewMode = this.reviewEmailData.find(
                (item) => item.reviewer === this.loggedEmail
              );
              element.status = 'Approval Pending';
            }
          });
          //this.calculateRowsPerPageOptionsForView()
        } else {
          this.orders = [];
          this.totalOrderRecords = 0;
          this.reviewMode = false;
        }
        this.cdr.detectChanges();
      });
    }
  }

  onPageChange(event: any) {
    this.bulkPageNo = event.first;
    this.orderFilters['page_number'] = event.page + 1;
    this.orderFilters['page_size'] = event.rows;
    this.getBulkOrders();
    this.rowsPerPage = event.rows;
  }
  pageChange(page: number) {
    if (this.paginator) {
      this.paginator.changePage(page - 1);
    }
  }
  onOrderPageChange(event: any) {
    this.orderPageNo = event.first;
    this.viewMorerderFilters.bulk_order_ids = this.selectedOrder.id;
    this.viewMorerderFilters.page_number = event.page + 1;
    this.viewMorerderFilters.page_size = event.rows;

    this.getOrders(this.viewMorerderFilters);
    this.rowsPerPageForViewMore = event.rows;
  }

  onOrderpageChange(page: number) {
    if (this.paginator) {
      this.paginator.changePage(page - 1);
    }
  }

  cancelOrder(id: string) {}

  sort(column: string): void {
    if (column === this.currentSortColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.sortDirection = 'asc';
    }

    this.orders.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  sortBulk(column: string): void {
    if (column === this.currentSortColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.sortDirection = 'asc';
    }

    this.bulkOrders.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  formatDateWithTime(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  export() {
    this.estampFilters['bulk_order_ids'] = [this.selectedOrder.id];
    this.estampFilters['estamp_fields'] = this.fieldsToDisplay;

    const today = new Date();
    const formattedDate = this.formatDateWithTime(today);

    let fileName = 'Consumptio Report' + '_' + formattedDate;

    this.exportExcelService
      .getOrderConsumption(this.estampFilters)
      .subscribe((res) => {
        if (res.status === 200 && res['message'] != 'No records found') {
          //this.exportExcelService.base64ToCSV(res['content'], fileName);
          this.messageService.add({
            severity: 'success',
            summary: res.message,
            icon: 'pi-check-circle',
          });
        } else {
          this.messageService.add({ severity: 'warn', summary: res.message });
        }
      });
  }

  convertStatusArraytoJson(arr: any[]): any {
    const result = {
      COMPLETED: 0,
      INITIATED: 0,
      IN_PROGRESS: 0,
      WAITING_FOR_STAMP: 0,
    };
    arr.forEach((item) => {
      result[item.status] = item.count;
    });

    return result;
  }

  getBulkOrderSummary(orderId: any) {
    this.orderService.getBulkOrderSummary(orderId).subscribe((res: any) => {
      if (res.status == 200) {
        this.ordersCount = res.content;
        this.pendingSignature =
          this.ordersCount.total_signature -
          this.ordersCount.total_signature_completed;
        this.stateStatusArray = res.content.state_status_data;
        this.ordersCount.state_status_data.forEach((state_status_data) => {
          state_status_data.statuses = this.convertStatusArraytoJson(
            state_status_data.statuses
          );
        });
      }
    });
  }

  getOrderDetail(orderId, content) {
    this.orderService.getOrderDetail(orderId).subscribe((res: any) => {
      let orderDetails = res['content'][0];
      this.openEditOrderPopup(orderDetails, content);
    });
  }

  openEditOrderPopup(orderDetails, content) {
    this.selectedOrderForEdit = orderDetails;

    this.getBranchDetails(orderDetails.state.id);
    this.editOrderId = orderDetails.order.id;

    this.commonFieldsOrderForm = this.formBuilder.group({
      referenceNumber: [orderDetails.order.referance_id || ''],
      branch: [orderDetails.order.branch || ''],
      state: [orderDetails.state.id || ''],
    });

    // Clear any existing forms from the form array
    this.estampForms.clear();

    // Loop through estamp_info and create a form for each item
    orderDetails.estamp.forEach((estampItem) => {
      let stampDutyPaidBy;
      if (estampItem.stamp_duty_paid_by === estampItem.first_party_name)
        stampDutyPaidBy = 'first_party_name';
      else stampDutyPaidBy = 'second_party_name';
      let executionDate = new Date(estampItem.execution_date);
      this.editEstampForm = this.formBuilder.group({
        estamp_id: [estampItem.id],
        secondPartyName: [
          estampItem.second_party_name || '',
          [noSpacesValidator(), Validators.maxLength(50)],
        ],
        stampDutyValue: [
          estampItem.stamp_duty_amount || '',
          [Validators.min(10)],
        ],
        stampDutyPaidBy: [stampDutyPaidBy || ''],
        execution_date: [executionDate || ''],
      });

      // Push the form group into the estampForms array
      this.estampForms.push(this.editEstampForm);
    });

    //Esign edit form
    this.esignForms.clear();

    orderDetails.esign.forEach((esignItem) => {
      this.editEsignForm = this.formBuilder.group({
        esign_id: [esignItem.id],
        name: [
          esignItem.name || '',
          [noSpacesValidator(), Validators.maxLength(50)],
        ],
        email: [
          esignItem.email || '',
          [
            Validators.email,
            Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
          ],
        ],
        contact_number: [
          esignItem.contact_number || '',
          [
            Validators.pattern(this.phonePattern),
            Validators.maxLength(10),
            Validators.minLength(10),
          ],
        ],
      });

      // Push the form group into the estampForms array
      this.esignForms.push(this.editEsignForm);
    });

    // Open the modal
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  onEditStateChange(evt) {
    this.getBranchDetails(evt.value);
  }

  editSelectedOrder() {
    this.submitted = true;
    if (this.editEstampForm.valid) {
      let estampsData = [];
      let esignsData = [];

      this.estampForms.value.forEach((element) => {
        let obj = {
          estamp_id: element.estamp_id,
          second_party_name: element.secondPartyName,
          stamp_duty_amount: element.stampDutyValue,
          stamp_duty_paid_by: element.stampDutyPaidBy,
          execution_date: this.dateEpochFormat(element.execution_date),
        };
        estampsData.push(obj);
      });

      this.esignForms.value.forEach((element) => {
        let obj = {
          esign_id: element.esign_id,
          name: element.name,
          email: element.email,
          contact_number: element.contact_number,
        };
        esignsData.push(obj);
      });

      let payload = {
        order_id: this.editOrderId,
        branch_id: this.commonFieldsOrderForm.controls['branch'].value,
        reference_number:
          this.commonFieldsOrderForm.controls['referenceNumber'].value,

        estamps: estampsData,
        esigns: esignsData,
      };

      this.orderService.updateOrder(payload).subscribe((res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Order Updated',
          detail: 'Order Updated Successfully',
        });
        this.onViewMore(this.selectedOrder);
        this.closeEditOrderPopup();
        this.submitted = false;
      });
    }
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      event.keyCode == 45
    ) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  getStateDetails() {
    this.orderService.getStates().subscribe((res: any) => {
      this.stateData = res['content'];
    });
  }

  getBranchDetails(id: number) {
    this.orderService.getBranchListbyStateId(id).subscribe((res: any) => {
      this.branchData = res['content'];
      this.branchData = this.branchData.filter(
        (element) => element.is_active === true
      );
    });
  }

  dateEpochFormat(executionDate) {
    const date = new Date((executionDate - 1) * 24 * 60 * 60 * 1000); // Adjust for Excel's epoch (Jan 1, 1900)
    this.addZeroTime(date);
    this.changeYearToCurrent(date);
    return date.getTime();
  }

  addZeroTime(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }

  changeYearToCurrent(date) {
    const currentYear = new Date().getFullYear();
    date.setFullYear(currentYear);
  }

  closeEditOrderPopup() {
    this.modalService.dismissAll();
  }

  calculateRowsPerPageOptions() {
    const options = [10, 20, 30, 50, 100]; // Default options

    // Calculate additional options based on totalRecords
    if (this.totalRecords > 100) {
      options.push(this.totalRecords); // Add the totalRecords as an option
    }

    // Sort the options array if needed
    this.rowsPerPageOptions = options.sort((a, b) => a - b);
  }

  onRowsPerPageChange(event: any) {
    this.rowsPerPage = event;
  }

  calculateRowsPerPageOptionsForView() {
    const options = [10, 20, 30, 50, 100]; // Default options

    // Calculate additional options based on totalRecords
    if (this.totalOrderRecords > 100) {
      options.push(this.totalOrderRecords); // Add the totalRecords as an option
    }

    // Sort the options array if needed
    this.rowsPerPageOptionsForViewMore = options.sort((a, b) => a - b);
  }

  onRowsPerPageChangeForViewMore(event: any) {
    this.rowsPerPageForViewMore = event;
  }

  approveAll(value) {
    const data = {
      order_id: '',
      bulk_id: this.selectedBulkOrder.bulk_order,
      reviewer_email: this.loggedEmail,
      action: value,
    };
    this.orderService.approveOrder(data).subscribe((res) => {
      this.onViewMore(this.selectedOrder);
      this.bulkOrderStatus = '';
      if (value === 'approve') {
        this.messageService.add({
          severity: 'success',
          detail: `Orders with Bulk Id ${this.selectedBulkOrder.bulk_order} are Approved`,
        });
      } else if (value === 'reject') {
        this.messageService.add({
          severity: 'success',
          detail: `Orders with Bulk Id ${this.selectedBulkOrder.bulk_order} are Rejected`,
        });
      } else if (value === 'reset') {
        this.messageService.add({
          severity: 'success',
          detail: `Orders with Bulk Id ${this.selectedBulkOrder.bulk_order} are Reinitiated`,
        });
      }
    });
  }

  onBackClick() {
    this.isViewMoreClicked = !this.isViewMoreClicked;
    this.bulkOrderChange.emit(this.isViewMoreClicked);
    this.pathRoute.navigate(['doqfy/orders/orders-list']);
    this.getBulkOrders();
  }

  getBulkOrderExcel(id) {
    this.excelOrderId = id;
    this.catEditService.getExcelDocument(id).subscribe((res) => {
      if (res['content'].length > 1 && res['content'] !== 'None') {
        this.showDownloadDoc = true;
        this.excelDocument = res['content'].slice(2, -1);

        // Convert the binary string to a Uint8Array
        const byteArray = atob(this.excelDocument);

        const wb: XLSX.WorkBook = XLSX.read(byteArray, {
          type: 'binary',
          cellDates: true,
        });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data first */
        this.jsonData = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true });

        // Detect percentage columns after we have the data
        this.percentageColumns = this.detectPercentageColumns(ws);

        this.orderExcelView();
      } else {
        this.showDownloadDoc = false;
        this.messageService.add({
          severity: 'warning',
          detail: 'File is not Generated',
        });
      }
    });
  }

  detectPercentageColumns(ws: XLSX.WorkSheet): Set<number> {
    const percentageColumns = new Set<number>();
    const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');

    // Keywords that indicate a monetary/numeric column — never treat as percentage
    const monetaryKeywords = ['amount', 'price', 'cost', 'fee', 'value', 'salary', 'charges', 'consideration'];

    // Check each column
    for (let col = range.s.c; col <= range.e.c; col++) {
      // Skip monetary columns regardless of cell format
      const headerCell = this.jsonData?.[0]?.[col];
      const headerStr = headerCell ? headerCell.toString().toLowerCase() : '';
      if (monetaryKeywords.some((k) => headerStr.includes(k))) {
        continue;
      }

      let isPercentageColumn = false;

      // Method 1: Check cell formatting AND confirm raw values look like percentages (0–1)
      for (let row = range.s.r + 1; row <= Math.min(range.e.r, 10); row++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
        const cell = ws[cellRef];

        if (
          cell &&
          cell.z &&
          typeof cell.z === 'string' &&
          cell.z.includes('%') &&
          typeof cell.v === 'number' &&
          cell.v >= 0 &&
          cell.v <= 1
        ) {
          isPercentageColumn = true;
          break;
        }
      }

      // Method 2: Check column header and data pattern
      if (!isPercentageColumn && headerStr) {
        if (
          headerStr.includes('percent') ||
          headerStr.includes('%') ||
          headerStr.includes('rate') ||
          headerStr.includes('ratio')
        ) {
          // Verify that values look like percentages (between 0 and 1)
          let percentageLikeCount = 0;
          let numericCount = 0;

          for (let row = 1; row < Math.min(this.jsonData.length, 11); row++) {
            const value = this.jsonData[row][col];
            if (typeof value === 'number' && !isNaN(value)) {
              numericCount++;
              if (value >= 0 && value <= 1) {
                percentageLikeCount++;
              }
            }
          }

          if (numericCount > 0 && percentageLikeCount / numericCount >= 0.7) {
            isPercentageColumn = true;
          }
        }
      }

      if (isPercentageColumn) {
        percentageColumns.add(col);
      }
    }

    return percentageColumns;
  }

  //--------------------------------Bulk Pdf ---------------------------------------------------------//

  // getBulkOrderPdf(id) {
  //   this.orderService.getBulkOrderPdfData(id).subscribe(
  //     (res) => {
  //       const blob = new Blob([res], { type: 'application/zip' });

  //       // Save the ZIP file using the FileSaver library
  //       saveAs(blob, `bulkOrder ${id}`);
  //     },
  //     (error: any) => {
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'File Not Found',
  //       });
  //     }
  //   );
  // }

  getBulkOrderPdf(id: number) {
    this.analyticsService.trackEvent('click_download_bulk_pdf', {
      bulk_id: id
    });

    this.orderService.getBulkOrderPdfData(id).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail:
              res.message ||
              'Your report is being processed. You will receive it via email shortly.',
            life: 5000,
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Information',
            detail: res.message || 'Your request is being processed',
            life: 5000,
          });
        }
      },
      (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error?.message || 'Failed to process your request',
          life: 5000,
        });
      }
    );
  }

  //------------------------------------------------------------------------------------------------------//

  downloadExcel() {
    this.fileName = `Bulk Order Id-${this.excelOrderId}.xlsx`;
    const byteArray = new Uint8Array(
      atob(this.excelDocument)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    const file = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const excelFile = URL.createObjectURL(file);
    const sanitizedURL: SafeResourceUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(excelFile);
    this.excelSource = sanitizedURL;
    saveAs(file, this.fileName);
    this.messageService.add({
      severity: 'success',
      detail: 'Generated with file name ' + this.fileName,
    });
  }

  viewPdfDocument(order) {
    this.orderService
      .getOrderDocumentReview(order.id)
      .subscribe((ODres: any) => {
        if (ODres['content'].length > 1 && ODres['content'] != 'None') {
          this.orderDocument = ODres['content'];
          this.showDownloadDoc = true;
          {
            const byteArray = new Uint8Array(
              atob(this.orderDocument)
                .split('')
                .map((char) => char.charCodeAt(0))
            );
            const file = new Blob([byteArray], { type: 'application/pdf' });
            this.fileURL = URL.createObjectURL(file);
            const sanitizedURL: SafeResourceUrl =
              this.sanitizer.bypassSecurityTrustResourceUrl(this.fileURL);
            this.pdfSource = sanitizedURL;
            this.orderView();
          }
        } else {
          this.showDownloadDoc = false;
          this.messageService.add({
            severity: 'warning',
            detail: 'Document is not Generated yet',
          });
        }
      });
  }
  closeModel() {
    this.modalService.dismissAll();
  }

  orderView() {
    if (this.showDownloadDoc) {
      this.modalService
        .open(this.viewStampOrder, {
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        })
        .result.then(
          (result) => {
            console.log(result);
          },
          (reason) => {
            console.log(reason);
          }
        );
    }
  }

  orderExcelView() {
    if (this.showDownloadDoc) {
      this.modalService
        .open(this.viewExcel, {
          size: 'xl',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        })
        .result.then(
          (result) => {
            console.log(result);
          },
          (reason) => {
            console.log(reason);
          }
        );
    }
  }

isDate(value: any): boolean {
  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }
  
  if (typeof value === 'string') {
    // Check if the string can be parsed into a valid Date
    const parsed = Date.parse(value);
    return !isNaN(parsed);
  }
  
  return false;
}

formatDate(cell: any, colIndex?: number): string {
  if (
    colIndex !== undefined &&
    this.percentageColumns &&
    this.percentageColumns.has(colIndex)
  ) {
    if (typeof cell === 'number') {
      return (cell * 100).toFixed(2) + '%';
    }
  }
  
  if (this.isDate(cell)) {
    // 1. Guarantee we have a Date object
    const dateObj = new Date(cell);
    
    // 2. THE FIX: Add 12 hours (43,200,000 milliseconds) to the date.
    // This safely completely bypasses the Excel 23:59:59 rounding bug
    // by pushing the time securely into the middle of the correct day.
    const safeDate = new Date(dateObj.getTime() + (12 * 60 * 60 * 1000));
    
    // 3. Extract the local date using the safely shifted object
    const day = String(safeDate.getDate()).padStart(2, '0');
    const month = String(safeDate.getMonth() + 1).padStart(2, '0');
    const year = safeDate.getFullYear();
    
    return `${day}-${month}-${year}`;
  }
  
  return cell;
}


  viewIndividualOrder(order, content) {
    // this.pathRoute.navigate(['/doqfy/orders/view-order', order?.id], {
    //   queryParams: {
    //     bulkOrderid: this.selectedOrder.id,
    //   }
    // });
    this.viewOrder(order, content);
  }

  viewOrder(order, content) {
    this.viewOrderId = {
      orderId: order.id,
      bulkOrderid: this.selectedOrder.id,
    };
    this.modalService
      .open(content, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
          this.onViewMore(this.selectedOrder);
        }
      );
  }

  // getProgressPercentage(): number {
  //   if (this.ordersCount) {
  //     if (this.ordersCount.total_orders === 0) {
  //       return 0;
  //     }
  //     return (this.ordersCount.completed_orders / this.ordersCount.total_orders) * 100;
  //   }
  // }

  // getTooltipText(): string {
  //   if (this.ordersCount)
  //     return `${this.ordersCount.completed_orders} out of ${this.ordersCount.total_orders} completed`;
  // }

  getProgressPercentage(index): number {
    if (this.ordersCountProgressBar[index]) {
      if (this.ordersCountProgressBar[index].total_orders === 0) {
        return 0;
      }
      this.progressPercentage[index] =
        (this.ordersCountProgressBar[index].completed_orders /
          this.ordersCountProgressBar[index].total_orders) *
        100;
      return (
        (this.ordersCountProgressBar[index].completed_orders /
          this.ordersCountProgressBar[index].total_orders) *
        100
      );
    }
  }

  getTooltipText(index): string {
    if (this.ordersCountProgressBar[index])
      this.progressBarTooltip[
        index
      ] = `${this.ordersCountProgressBar[index].completed_orders} out of ${this.ordersCountProgressBar[index].total_orders} completed`;
    return `${this.ordersCountProgressBar[index].completed_orders} out of ${this.ordersCountProgressBar[index].total_orders} completed`;
  }

  calculateTotalStampDuty(estampInfo: any[]): number {
    return estampInfo.reduce((sum, item) => {
      const amount = parseFloat(item.stamp_duty_amount);
      return !isNaN(amount) ? sum + amount : sum;
    }, 0);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.unsubscribeService.unsubscribeAll();
  }
  exportESBTR(): void {
  if (!this.selectedOrder) {
    this.messageService.add({ 
      severity: 'warn', 
      summary: 'Warning', 
      detail: 'Please select a bulk order first.' 
    });
    return;
  }

  this.isExporting = true;

  this.orderService.exportEsbtrFiles(this.selectedOrder.id).subscribe({
    next: (response: any) => {
      this.isExporting = false;
      
      if (response.status === 200 && response.content) {
        this.downloadZipFile(response.content, `ESBTR_Export_${this.selectedOrder.id}.zip`);
      } else {
        this.messageService.add({ 
          severity: 'info', 
          summary: 'No Data', 
          detail: 'No ESBTR files available for export.' 
        });
      }
    },
    error: (error: any) => {
      this.isExporting = false;
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Export Failed', 
        detail: 'Failed to export ESBTR files.' 
      });
    }
  });
}

private downloadZipFile(base64Data: string, fileName: string): void {
  try {
    const cleanBase64 = base64Data.replace(/^b'|'$/g, '');
    const binaryString = atob(cleanBase64);
    const bytes = new Uint8Array(binaryString.length);
    
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    const blob = new Blob([bytes], { type: 'application/zip' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
}

}